import { useEffect, useState } from 'react';
import { Paper, useTheme, Skeleton, Grid } from '@mui/material';
import { ScreenType } from '@/types/enums/media';
import {
    useAccounts,
    useWindowDimensions,
    useQueryParams,
    useParticipationInfoQuery,
} from '@/hooks';
import { AvailableBalance } from './AvailableBalance/AvailableBalance';
import { AccountSelector } from '@/components/blocks/wallet/AccountSelector/AccountSelector';
import { TransactionTableSection } from '@/components/blocks/wallet/Transactions/TransactionTableSection/TransactionTableSection';
import { NoAccountExists } from '../NoAccountExists/NoAccountExists';

export const Transactions = () => {
    const theme = useTheme();
    const { screenType } = useWindowDimensions();
    const { key } = useQueryParams();

    const [showArchivedTransactions, setShowArchivedTransactions] = useState(false);
    const { participationInfo } = useParticipationInfoQuery(key);

    const { selectedAccount, accounts, handleChangeAccountTab, isLoading } = useAccounts();

    if (
        participationInfo?.accountId &&
        selectedAccount?.accountId &&
        participationInfo?.accountId !== selectedAccount?.accountId
    ) {
        handleChangeAccountTab(participationInfo.accountId);
    }

    useEffect(() => {
        setShowArchivedTransactions(Boolean(participationInfo?.isArchivedTransaction));
    }, [participationInfo?.isArchivedTransaction]);

    const isTabletOrLessScreen =
        screenType === ScreenType.Tablet || screenType === ScreenType.Mobile;

    return (
        <>
            {isLoading && (
                <Grid container>
                    <Grid size={12}>
                        <Skeleton data-testid="skeleton" height={150} />
                        <Skeleton data-testid="skeleton" height={70} />
                    </Grid>
                </Grid>
            )}
            {accounts && !!accounts.length && selectedAccount && (
                <>
                    <AvailableBalance
                        currencyCode={selectedAccount.currencyCode}
                        currencySymbol={selectedAccount.currencySymbol}
                        currencySymbolPosition={selectedAccount.currencySymbolPosition}
                        balance={selectedAccount.balance}
                        balanceNonTaxable={selectedAccount.balanceNonTaxable}
                    />
                    <AccountSelector
                        accounts={accounts}
                        tabVal={selectedAccount.accountId}
                        setTabVal={handleChangeAccountTab}
                    />
                    <Paper
                        elevation={isTabletOrLessScreen ? 0 : 1}
                        sx={{
                            p: isTabletOrLessScreen ? 0 : 4,
                            display: { md: 'block' },
                            border: isTabletOrLessScreen ? '0' : null,
                            backgroundColor: isTabletOrLessScreen
                                ? theme.palette.background.default
                                : null,
                        }}
                    >
                        <TransactionTableSection
                            selectedAccount={selectedAccount}
                            participationKey={key}
                            showArchivedTransactions={showArchivedTransactions}
                            setShowArchivedTransactions={setShowArchivedTransactions}
                        />
                    </Paper>
                </>
            )}
            {!isLoading && (!accounts || (!accounts.length && <NoAccountExists />))}
        </>
    );
};
